import Vue from 'vue'
import Validate from 'vee-validate'

Vue.use(Validate, {
  events: 'change'
})
